import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import CardSchedule from "../../CardSchedule";
import { SCButtonAddInput } from "../../Buttons/styles";
import { getNextClass } from "../../../store/middleware";
import PlaceholderText from "../../Placeholder/PlaceholderText";
import { endLoading, initLoading } from "../../../store/slices/generics.slice";

import { Container, BoxClasses, ColumnsClasses, WrappreTitle, Label, Time } from "./styles";

const NextClassCSCM = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { allClasses } = useSelector((state) => state.genericReducer);

  const getData = async () => {
    dispatch(initLoading());
    await dispatch(getNextClass());
    dispatch(endLoading());
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  return (
    <Container>
      <BoxClasses>
        <ColumnsClasses>
          <WrappreTitle>
            <Label>{t("BTN_UPCOMING_CLASS")}</Label>
            <div>
              <Time></Time>
            </div>
          </WrappreTitle>

          {allClasses?.length > 0 ? (
            allClasses?.map((schedule) => <CardSchedule key={JSON.stringify(schedule)} schedule={schedule} />)
          ) : (
            <PlaceholderText />
          )}
        </ColumnsClasses>

        {/* <ColumnsClasses>
          <WrappreTitle>
            <Label>Aulas a Iniciar</Label>

            <div>
              <CurrentTime>Horário atual</CurrentTime>
              <Time>
                <FaCaretLeft size={18} color="#004fff" />
                14:30h
                <FaCaretRight size={18} color="#004fff" />
              </Time>
            </div>
          </WrappreTitle>

          {allClasses?.length > 0 ? (
            allClasses?.map((schedule) => <CardSchedule key={JSON.stringify(schedule)} schedule={schedule} />)
          ) : (
            <PlaceholderText />
          )}
        </ColumnsClasses> */}
      </BoxClasses>

      <Link to={`/calendar/`}>
        <SCButtonAddInput mt="15px" ml="auto" mb="0" mr="auto" background="#004fff" color="#fff">
          {t("BTN_VIEW_ALL")}
        </SCButtonAddInput>
      </Link>
    </Container>
  );
};

export default NextClassCSCM;
